import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';

export const analyticsInfoStateSelector = ({ analytics }: DefaultRootState) =>
  analytics;

export const getRulerInteractionSelector = createSelector(
  analyticsInfoStateSelector,
  ({ ruler }) => ruler.interaction,
);

export const getEcgTimeStartedSelector = createSelector(
  analyticsInfoStateSelector,
  ({ ecg }) => ecg.timeStarted,
);

export const getRulerTimeStarted = createSelector(
  analyticsInfoStateSelector,
  ({ ruler }) => ruler.timeStarted,
);
